/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2RightArrowLongCircle/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2RightArrowLongCircle({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2RightArrowLongCircle",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2RightArrowLongCircle.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-Z6gqXm': alignSelf,'--mt-2-Z6gqXm': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z6gqXm': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z6gqXm': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z6gqXm': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z6gqXm': opacity,'--w-10-Z6gqXm': typeof width === 'number' ? `${width}px` : width,'--h-11-Z6gqXm': typeof height === 'number' ? `${height}px` : height,'--f-12-Z6gqXm': fill,'--a-7-Z6gqXm': isAnimated ? animation : "none",'--sd-8-Z6gqXm': isAnimated ? strokeDashoffset : 0,'--sd-9-Z6gqXm': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2RightArrowLongCircle.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_5304_5392)"
 className="views-block"
>
<path
  data-testid="Tysiav2RightArrowLongCircle.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M0 7a7 7 0 1114 0A7 7 0 010 7zm6.53-3.53a.75.75 0 00-1.06 1.06L7.94 7 5.47 9.47a.75.75 0 101.06 1.06l3-3a.75.75 0 000-1.06l-3-3z"
 style={{'--f-12-Z6gqXm': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}